import { createFileRoute } from "@tanstack/react-router"
import { usePageTitle } from "@/contexts/PageTitleContext.tsx"
import { useEffect } from "react"
import { Separator } from "@/components/ui/separator.tsx"
import { useTranslation } from "react-i18next"
import { getStoredLocale } from "@/lib/utils.ts"

export const Route = createFileRoute("/_protected/safety")({
  ssr: false,
  component: RouteComponent,
})

function RouteComponent() {
  const { setTitle } = usePageTitle()
  const { t } = useTranslation()
  const locale = getStoredLocale()

  useEffect(() => {
    setTitle(t("sidebar.safety"))
  }, [setTitle])

  return locale === "ar" ? (
    <div>
      <div dir="rtl" className="text-right text-[15px] leading-[1.8]">
        <h2 className="mt-6 mb-2 text-[23px] font-bold">
          تصنيف مستويات المخاطر
        </h2>

        <ul className="list-disc space-y-3 ps-8">
          <li>
            <strong>المستوى الأول (منخفض)</strong>: المراقبة العامة، المضايقة
            الإلكترونية، التخويف البسيط
          </li>

          <li>
            <strong>المستوى الثاني (متوسط)</strong>: سرقة المعدات، المضايقة
            القانونية، التحذيرات الرسمية، مشاكل التأشيرات/التصاريح
          </li>

          <li>
            <strong>المستوى الثالث (مرتفع)</strong>: التهديدات المباشرة،
            الاعتداء الجسدي، الاعتقال، تهديدات الاختفاء القسري
          </li>

          <li>
            <strong>المستوى الرابع (حرج)</strong>: تهديدات قتل وشيكة، المطاردة
            الفعلية، تهديد الأسرة، المواجهة المسلحة
          </li>
        </ul>

        <h2 className="mt-8 mb-2 text-[23px] font-bold">
          خطوات السلامة الفورية
        </h2>

        <ul className="list-disc space-y-3 ps-8">
          <li>
            <strong>أبلِغوا</strong>
            المحرر المباشر في إيجاب أو فريق التحرير فوراً
            <a
              href="mailto:editorial@egab.co"
              className="text-primary underline"
            >
              editorial@egab.co
            </a>
          </li>

          <li>
            ضعوا خطة لإجراءات
            <strong>التواصل في أوقات الأزمات</strong>و
            <strong>أنشئوا كلمات سر مع جهات الاتصال الموثوقة</strong>
            (أي الأسرة والأصدقاء) بحسب مستويات الطوارئ المختلفة.
          </li>

          <li>
            <strong>أوقفوا أي عمل على قصتكم (إذا لم تُنشر بعد)</strong>
            حتى يتم ضمان سلامتكم.
          </li>

          <li>
            إذا قررتم متابعة العمل على القصة،
            <strong>
              اعملوا مع محرري إيجاب لضمان وضع بروتوكولات أمنية مناسبة
            </strong>
          </li>

          <li>
            ضعوا جدولاً
            <strong>لتحديثات السلامة والمتابعة</strong>
            مع محرر إيجاب مباشرة.
          </li>

          <li>
            أنشئوا
            <strong>خطط تواصل احتياطية</strong>
            في حالة فشل الوسائل الأساسية.
          </li>

          <li>
            حددوا مسبقاً مواقع
            <strong>لبيوت آمنة أو إقامة مؤقتة في حالات الطوارئ</strong>
          </li>

          <li>
            <strong>حضروا حقيبة للطوارئ تتضمن</strong>: مبلغ مالي، وثائق، أدوية،
            أجهزة شحن، إمدادات أساسية.
          </li>

          <li>
            اختبروا
            <strong>طرق متعددة للسلامة/الخروج الآمن</strong>
          </li>
        </ul>

        <h3 className="mt-6 mb-2 text-[18px] font-bold">توثيق كل شيء</h3>

        <ul className="list-disc space-y-3 ps-8">
          <li>
            احتفظوا بلقطات الشاشة لجميع الرسائل التهديدية مع الطوابع الزمنية.
          </li>
          <li>
            وثقوا أي محاولات للمراقبة بالصور/الفيديو عندما يكون ذلك آمناً.
          </li>
          <li>سجلوا التواريخ والأوقات والمواقع وأوصاف التهديدات.</li>
          <li>احتفظوا بنسخ إلكترونية في مكان آمن ومشفر مع نسخ احتياطية.</li>
          <li>
            شاركوا الوثائق مع جهات الاتصال الموثوقة ومنظمات حماية الصحفيين.
          </li>
        </ul>

        <h3 className="mt-6 mb-2 text-[18px] font-bold">تعزيز الأمان الشخصي</h3>

        <ul className="list-disc space-y-3 ps-8">
          <li>غيّروا الروتين اليومي والطرق.</li>
          <li>
            أبلِغوا جهات الاتصال الموثوقة بتحركاتكم وضعوا جدولاً للمتابعة
            المنتظمة.
          </li>
          <li>فكروا في الانتقال المؤقت داخل المدينة أو خارجها، إن أمكن.</li>
          <li>كونوا حذرين للغاية بشأن من يعرف موقعكم.</li>
          <li>استخدموا وسائل نقل مختلفة وتجنبوا الأنماط المتوقعة.</li>
          <li>
            فعلوا تدابير أمنية في المنزل/المكتب (كاميرات، إنذارات، أقفال محكمة).
          </li>
        </ul>

        <h3 className="mt-6 mb-2 text-[18px] font-bold">
          التواصل والأمان الرقمي
        </h3>

        <ul className="list-disc space-y-3 ps-8">
          <li>
            انتقلوا فوراً إلى تطبيقات المراسلة المشفرة (Signal، ProtonMail).
          </li>
          <li>افترضوا أن جميع المكالمات الهاتفية والرسائل العادية مراقَبة.</li>
          <li>فكروا في الحصول على هاتف/رقم جديد إذا تصاعدت التهديدات.</li>
          <li>استخدموا متصفح Tor للبحث الحساس.</li>
          <li>
            استخدموا خدمة VPN موثوقة مع الحماية التلقائية عند انقطاع الاتصال
            (تجنبوا خدمات VPN المجانية).
          </li>
          <li>فعّلوا المصادقة الثنائية على جميع الحسابات.</li>
          <li>قوموا بتشفير القرص الكامل على جميع الأجهزة.</li>
          <li>استخدموا أدوات الحذف الآمن للملفات الحساسة.</li>
        </ul>

        <h2 className="mt-8 mb-2 text-[23px] font-bold">
          جهات الاتصال الطارئة
        </h2>

        <h3 className="mt-6 mb-2 text-[18px] font-bold">
          منظمات المساعدة الأساسية للصحفيين
        </h3>

        <h4 className="mt-5 mb-2 font-bold">لجنة حماية الصحفيين (CPJ)</h4>

        <ul className="list-disc space-y-3 ps-8">
          <li>
            <strong>البريد الإلكتروني الطارئ:</strong>
            <a
              href="mailto:emergencies@cpj.org"
              className="text-primary underline"
            >
              emergencies@cpj.org
            </a>
          </li>

          <li>
            <strong>الهاتف:</strong>
            <a
              href="tel:+12124651004"
              dir="ltr"
              className="inline-block text-primary underline"
            >
              +1 212 465 1004
            </a>
          </li>

          <li>
            <strong>الخدمات:</strong>
            دعم الإخلاء الطارئ، الدعم الطبي، الدعم القانوني، المساعدة المالية،
            الاستشارات الأمنية.
          </li>
        </ul>

        <h4 className="mt-5 mb-2 font-bold">مراسلون بلا حدود (RSF)</h4>

        <ul className="list-disc space-y-3 ps-8">
          <li>
            <strong>البريد الإلكتروني الطارئ:</strong>
            <a
              href="mailto:assistance@rsf.org"
              className="text-primary underline"
            >
              assistance@rsf.org
            </a>
            <span className="mx-1">|</span>
            <a
              href="mailto:assistance2@rsf.org"
              className="text-primary underline"
            >
              assistance2@rsf.org
            </a>
          </li>

          <li>
            <strong>الهاتف:</strong>
            <a
              href="tel:+33144836056"
              dir="ltr"
              className="inline-block text-primary underline"
            >
              +33 1 44 83 60 56
            </a>
            أو
            <a
              href="tel:+33144838466"
              dir="ltr"
              className="inline-block text-primary underline"
            >
              +33 1 44 83 84 66
            </a>
          </li>

          <li>
            <strong>الخدمات:</strong>
            الدعم المالي لإعادة التوطين الطارئ، الرسوم القانونية، الرسوم الطبية،
            استبدال المعدات.
          </li>
        </ul>

        <h4 className="mt-5 mb-2 font-bold">الاتحاد الدولي للصحفيين (IFJ)</h4>

        <ul className="list-disc space-y-3 ps-8">
          <li>
            <strong>البريد الإلكتروني:</strong>
            <a href="mailto:ifj@ifj.org" className="text-primary underline">
              ifj@ifj.org
            </a>
          </li>

          <li>
            <strong>الهاتف:</strong>
            <a
              href="tel:+3222352200"
              dir="ltr"
              className="inline-block text-primary underline"
            >
              +32 2 235 22 00
            </a>
          </li>

          <li>
            <strong>الخدمات:</strong>
            المساعدة المالية، العنف، الرسوم القانونية، الدعم في المنفى، الرسوم
            الطبية.
          </li>
        </ul>

        <h4 className="mt-5 mb-2 font-bold">مؤسسة روري بيك</h4>

        <ul className="list-disc space-y-3 ps-8">
          <li>
            <strong>الموقع الإلكتروني:</strong>
            <a
              href="https://rorypecktrust.org"
              target="_blank"
              rel="noopener noreferrer"
              dir="ltr"
              className="inline-block text-primary underline"
            >
              rorypecktrust.org
            </a>
          </li>

          <li>
            <strong>البريد الإلكتروني:</strong>
            <a
              href="mailto:info@rorypecktrust.org"
              className="text-primary underline"
            >
              info@rorypecktrust.org
            </a>
          </li>

          <li>
            <strong>الهاتف:</strong>
            <a
              href="tel:+442032197860"
              dir="ltr"
              className="inline-block text-primary underline"
            >
              +44 20 3219 7860
            </a>
          </li>

          <li>
            <strong>صندوق الأزمات:</strong>
            <a
              href="https://rorypecktrust.org/get-help/crisis/crisis-fund/"
              target="_blank"
              rel="noopener noreferrer"
              className="break-all text-primary underline"
            >
              https://rorypecktrust.org/get-help/crisis/crisis-fund/
            </a>
          </li>

          <li>
            <strong>الخدمات:</strong>
            المساعدة المالية والدعم العملي للصحفيين المستقلين في الأزمات.
          </li>
        </ul>

        <h3 className="mt-6 mb-2 text-[18px] font-bold">
          منظمات الدعم الإضافية
        </h3>

        <h4 dir="ltr" className="mt-5 mb-2 text-right font-bold">
          Free Press Unlimited
        </h4>

        <ul className="list-disc space-y-3 ps-8">
          <li>
            <strong>البريد الإلكتروني الطارئ:</strong>
            <a
              href="mailto:reportersrespond@freepressunlimited.org"
              className="text-primary underline"
            >
              reportersrespond@freepressunlimited.org
            </a>
          </li>

          <li>
            <strong>الهاتف:</strong>
            <a
              href="tel:+31208000400"
              dir="ltr"
              className="inline-block text-primary underline"
            >
              +31 20 8000 400
            </a>
          </li>

          <li>
            <strong>الخدمات:</strong>
            صندوق المساعدة الطارئة للمراسلين.
          </li>
        </ul>

        <h4 className="mt-5 mb-2 font-bold">
          المؤسسة الإعلامية النسائية الدولية (IWMF)
        </h4>

        <ul className="list-disc space-y-3 ps-8">
          <li>
            <strong>صندوق الطوارئ:</strong>
            متاح للصحفيين من الذكور والإناث.
          </li>

          <li>
            <strong>الخدمات:</strong>
            المساعدة الطبية، مساعدة الإخلاء، المساعدة القانونية.
          </li>

          <li>
            <strong>البريد الإلكتروني:</strong>
            <a href="mailto:info@iwmf.org" className="text-primary underline">
              info@iwmf.org
            </a>
          </li>

          <li>
            <strong>الهاتف:</strong>
            <a
              href="tel:+12024961992"
              dir="ltr"
              className="inline-block text-primary underline"
            >
              +1 202 496 1992
            </a>
          </li>
        </ul>

        <h4 className="mt-5 mb-2 font-bold">المنظمات الإقليمية المتخصصة</h4>

        <ul className="list-disc space-y-3 ps-8">
          <li>
            <strong>مادة 19:</strong>
            <a
              href="mailto:info@article19.org"
              className="text-primary underline"
            >
              info@article19.org
            </a>
            (الدعم القانوني، حرية التعبير)
          </li>

          <li>
            <strong>فهرس الرقابة:</strong>
            <a
              href="tel:+442072602660"
              dir="ltr"
              className="inline-block text-primary underline"
            >
              +44 20 7260 2660
            </a>
            (مقرها المملكة المتحدة)
          </li>

          <li>
            <strong>منظمة القلم الدولية:</strong>
            <a
              href="mailto:info@pen-international.org"
              className="text-primary underline"
            >
              info@pen-international.org
            </a>
            (الكتاب المعرضون للخطر)
          </li>

          <li>
            <strong>مبادرة الدفاع القانوني الإعلامي:</strong>
            <a
              href="mailto:info@mediadefence.org"
              className="text-primary underline"
            >
              info@mediadefence.org
            </a>
            (المساعدة القانونية)
          </li>
        </ul>

        <p className="my-6 font-bold">
          ملحوظة مهمة: التزموا بإرشادات السلامة المناسبة لظروف عملكم ومجالات
          تخصصكم الصحفي، واحرصوا على متابعة آخر التحديثات الأمنية باستمرار.
          تذكروا دائماً: سلامتكم الشخصية تأتي قبل أي مادة صحفية مهما بلغت
          أهميتها.
        </p>

        <p className="my-6 font-bold">نشر في 11 سبتمبر 2025</p>
      </div>
    </div>
  ) : (
    <div className="mx-auto w-full pb-6 leading-relaxed">
      <h1 className="mb-6 text-xl font-bold">Risk Level Classification</h1>
      <ul className="mb-6 space-y-2">
        <li>
          <strong>Level 1 (Low):</strong> General surveillance, online
          harassment, minor intimidation
        </li>
        <li>
          <strong>Level 2 (Medium):</strong> Equipment theft, legal harassment,
          official warnings, visa/permit issues
        </li>
        <li>
          <strong>Level 3 (High):</strong> Direct threats, physical assault,
          detention, forced disappearance threats
        </li>
        <li>
          <strong>Level 4 (Critical):</strong> Imminent death threats, active
          pursuit, family threatened, armed confrontation
        </li>
      </ul>

      <Separator className="mb-4" />

      <h2 className="mb-4 text-xl font-bold uppercase">
        Immediate Safety Steps
      </h2>
      <ul className="mb-4 list-disc space-y-2 pl-5">
        <li>
          <strong>Notify</strong> your direct Egab assignment editor or{" "}
          <a href="mailto:editorial@egab.co" className="text-primary underline">
            editorial@egab.co
          </a>{" "}
          immediately
        </li>
        <li>
          Establish <strong>crisis communication</strong> procedures and{" "}
          <strong>create code words with trusted contacts</strong> (i.e., family
          and friends) for different emergency levels
        </li>
        <li>
          <strong>
            Suspend any work on your story (if not published already)
          </strong>{" "}
          until safety is assured
        </li>
        <li>
          If continuing,{" "}
          <strong>work with editors to ensure proper security</strong> protocols
          are in place
        </li>
        <li>
          Establish <strong>safety briefings and check-in</strong> schedules
          with your editor
        </li>
        <li>
          Create <strong>backup communication plans</strong> if primary methods
          fail
        </li>
        <li>
          Pre-identify <strong>safe houses or emergency accommodation</strong>
        </li>
        <li>
          <strong>Go-bag with essentials</strong>: cash, documents, medications,
          chargers, basic supplies
        </li>
        <li>
          Map and practice multiple <strong>safety/exit routes</strong>
        </li>
      </ul>

      <h3 className="mb-2 text-lg font-semibold">Document Everything</h3>
      <ul className="mb-6 list-disc space-y-2 pl-5">
        <li>Screenshot all threatening messages with timestamps</li>
        <li>Document any surveillance incidents with photos/video when safe</li>
        <li>Record dates, times, locations, and descriptions of threats</li>
        <li>Keep copies in secure, encrypted storage with cloud backup</li>
        <li>Share documentation with trusted contacts and organizations</li>
      </ul>

      <h3 className="mb-2 text-lg font-semibold">Enhance Personal Security</h3>
      <ul className="mb-6 list-disc space-y-2 pl-5">
        <li>Vary daily routines and routes significantly</li>
        <li>
          Inform trusted contacts of movements and establish check-in schedules
        </li>
        <li>
          Consider temporary relocation within the city or outside it, if
          possible
        </li>
        <li>Be extremely cautious about who knows your location</li>
        <li>
          Use different transportation methods and avoid predictable patterns
        </li>
        <li>
          Install security measures at home/office (cameras, alarms, reinforced
          locks)
        </li>
      </ul>

      <h3 className="mb-2 text-lg font-semibold">
        Communication &amp; Digital Security
      </h3>
      <ul className="mb-4 list-disc space-y-2 pl-5">
        <li>
          Switch immediately to encrypted messaging apps (Signal, ProtonMail)
        </li>
        <li>Assume all phone calls and regular messages are monitored</li>
        <li>Consider getting a new phone/number if threats escalate</li>
        <li>Use Tor browser for sensitive research</li>
        <li>
          Use a reliable VPN service with automatic disconnect protection (avoid
          free VPN services)
        </li>
        <li>Enable two-factor authentication on all accounts</li>
        <li>Full-disk encryption on all devices</li>
        <li>Secure deletion tools for sensitive files</li>
        <li>Burner devices for high-risk assignments</li>
      </ul>

      <Separator className="mb-4" />

      <h2 className="mb-4 text-xl font-bold">Emergency Contacts</h2>

      <h3 className="mb-2 text-lg font-semibold">
        Primary Journalist Assistance Organizations
      </h3>

      <div className="mb-4">
        <p className="font-semibold">Committee to Protect Journalists (CPJ)</p>
        <p>
          Emergency Email:{" "}
          <a
            href="mailto:emergencies@cpj.org"
            className="text-primary underline"
          >
            emergencies@cpj.org
          </a>
        </p>
        <p>
          Phone:{" "}
          <a href="tel:+12124651004" className="text-primary underline">
            +1 (212) 465-1004
          </a>
        </p>
        <p>
          Services: Emergency relocation support, medical support, legal
          support, financial assistance, safety consultations
        </p>
      </div>

      <div className="mb-4">
        <p className="font-semibold">Reporters Without Borders (RSF)</p>
        <p>
          Emergency Emails:{" "}
          <a
            href="mailto:assistance@rsf.org"
            className="text-primary underline"
          >
            assistance@rsf.org
          </a>{" "}
          |{" "}
          <a
            href="mailto:assistance2@rsf.org"
            className="text-primary underline"
          >
            assistance2@rsf.org
          </a>
        </p>
        <p>
          Phone:{" "}
          <a href="tel:+33144836056" className="text-primary underline">
            (+33) (0)1 44 83 60 56
          </a>{" "}
          or{" "}
          <a href="tel:+33144838466" className="text-primary underline">
            (+33) (0)1 44 83 84 66
          </a>
        </p>
        <p>
          Services: Financial support for emergency resettlement, legal fees,
          medical fees, equipment replacement
        </p>
      </div>

      <div className="mb-4">
        <p className="font-semibold">
          International Federation of Journalists (IFJ)
        </p>
        <p>
          Email:{" "}
          <a href="mailto:ifj@ifj.org" className="text-primary underline">
            ifj@ifj.org
          </a>
        </p>
        <p>
          Phone:{" "}
          <a href="tel:+3222352200" className="text-primary underline">
            +32 (0)2 235 22 00
          </a>
        </p>
        <p>
          Services: Financial assistance for threats, violence, prosecution,
          settlement in exile, illness through Safety Fund
        </p>
      </div>

      <div className="mb-6">
        <p className="font-semibold">Rory Peck Trust</p>
        <p>
          Website:{" "}
          <a
            href="https://rorypecktrust.org"
            className="text-primary underline"
          >
            https://rorypecktrust.org
          </a>
        </p>
        <p>
          Email:{" "}
          <a
            href="mailto:info@rorypecktrust.org"
            className="text-primary underline"
          >
            info@rorypecktrust.org
          </a>
        </p>
        <p>
          Phone:{" "}
          <a href="tel:+442032197860" className="text-primary underline">
            +44 (0)203 219 7860
          </a>
        </p>
        <p>
          Apply for Crisis Fund:{" "}
          <a
            href="https://rorypecktrust.org/get-help/crisis/crisis-fund/"
            className="text-primary underline"
          >
            rorypecktrust.org/get-help/crisis/crisis-fund
          </a>
        </p>
        <p>
          Services: Financial assistance and practical support for freelance
          journalists in crisis
        </p>
      </div>

      <h3 className="mb-2 text-lg font-semibold">
        Additional Support Organizations
      </h3>

      <div className="mb-4">
        <p className="font-semibold">Free Press Unlimited</p>
        <p>
          Emergency Email:{" "}
          <a
            href="mailto:reportersrespond@freepressunlimited.org"
            className="text-primary underline"
          >
            reportersrespond@freepressunlimited.org
          </a>
        </p>
        <p>
          Phone:{" "}
          <a href="tel:+31208000400" className="text-primary underline">
            +31 20 8000 400
          </a>
        </p>
        <p>Services: Emergency assistance fund for reporters</p>
      </div>

      <div className="mb-6">
        <p className="font-semibold">
          International Women's Media Foundation (IWMF)
        </p>
        <p>Emergency Fund: Available for male and female journalists</p>
        <p>
          Email:{" "}
          <a href="mailto:info@iwmf.org" className="text-primary underline">
            info@iwmf.org
          </a>
        </p>
        <p>
          Phone:{" "}
          <a href="tel:+12024961992" className="text-primary underline">
            (+1) 202-496-1992
          </a>
        </p>
        <p>Services: Medical aid, relocation assistance, legal help</p>
      </div>

      <h3 className="mb-2 text-lg font-semibold">
        Regional Specialist Organizations
      </h3>
      <ul className="mb-8 space-y-1">
        <li>
          <strong>ARTICLE 19:</strong>{" "}
          <a
            href="mailto:info@article19.org"
            className="text-primary underline"
          >
            info@article19.org
          </a>{" "}
          (Legal support, freedom of expression)
        </li>
        <li>
          <strong>Index on Censorship:</strong>{" "}
          <a href="tel:+442072602660" className="text-primary underline">
            +44 20 7260 2660
          </a>{" "}
          (UK-based press freedom)
        </li>
        <li>
          <strong>PEN International:</strong>{" "}
          <a
            href="mailto:info@pen-international.org"
            className="text-primary underline"
          >
            info@pen-international.org
          </a>{" "}
          (Writers at risk)
        </li>
        <li>
          <strong>Media Legal Defence Initiative:</strong>{" "}
          <a
            href="mailto:info@mediadefence.org"
            className="text-primary underline"
          >
            info@mediadefence.org
          </a>{" "}
          (Legal assistance)
        </li>
      </ul>

      <Separator className="mb-4" />

      <p className="mb-6 rounded bg-yellow-100 p-4">
        <strong>IMPORTANT:</strong> These safety tips should be customized to
        your specific circumstances, location, and type of journalism. Regular
        training and updates are essential.{" "}
        <strong>When in doubt, prioritize your safety over any story.</strong>
      </p>

      <p className="pb-6 text-sm text-slate-500">
        Document Released: Sep 11, 2025
      </p>
    </div>
  )
}
